// entry.client.js
import createApp from './src/app.js';
import siteConfig from './src/config/site';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  const mountEl = document.getElementById('app');
  // 有 SSR 预渲染内容时走 hydration，纯客户端 dev 则普通挂载
  const hydrate = mountEl && mountEl.hasChildNodes();
  app.$mount('#app', hydrate);
});

function updateMeta(route) {
  const meta = route.meta || {};
  const defaultDescript =
    'Download WhatsApp Aero APK latest version v10.9 for Android. Explore advanced privacy features, custom themes, anti-delete messages, installation guides, updates, comparisons, and FAQs.';
  const defaultKeyword = 'WhatsApp Aero, WhatsApp Aero APK';
  const defaultCanonical = siteConfig.siteUrl + '/';

  document.title =
    meta.title ||
    'WhatsApp Aero APK Download v10.9 Latest Version 2026 | Anti-Ban & Official';

  setMetaTag('description', meta.description || defaultDescript);
  setMetaTag('og:description', meta.description || defaultDescript);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setLinkTag(
    'canonical',
    meta.link?.find((link) => link.rel === 'canonical')?.href || defaultCanonical
  );

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
}
